$(document).ready(function () {
  $('.js-openMenu').on("click", function () {
    $(this).toggleClass('active');
    $('.mobileMenu').toggleClass('opened');
    $('body').addClass('noscroll');
  });

  $('.js-close').on("click", function () {
    $('.mobileMenu').removeClass('opened');
    $('body').removeClass('noscroll');
  });

  $('body').on("click", '.js-prev', function () {
    
    var el = $(this);
    $(".mobileMenu ul.opened").removeClass("opened");
    $("[data-menu].actived").removeClass("actived");
    $(".js-prev").remove();
  });

  $('.mobileMenu li').each(function() {
    if ( $(this).find('ul').length ) {
      $(this).addClass('withSubmenu');
      $(this).find('a').append('<span class="mobileMenu__submenuSwitcher"></span>');
    }
  });
  

  function submenuSwitcher() {
    $("[data-menu] .mobileMenu__submenuSwitcher").on("click", function (e) {
        if ($(e.target).hasClass('mobileMenu__submenuSwitcher')) {
          e.preventDefault();
          var el = $(this).parent();
          el.toggleClass("actived");
          el.next('ul').toggleClass("opened");
        }
    });
  }
  submenuSwitcher();

  $('.js-searchBox .searchBox__icon').on('click', function() {
    $(this).parent().toggleClass('active');
    $('.js-searchBox input').focus();
    $('.mobileMenu__language').toggleClass('hide');
  });

});
